import { render, staticRenderFns } from "./addPlushGoods.vue?vue&type=template&id=42a1da8b"
import script from "./addPlushGoods.vue?vue&type=script&lang=js"
export * from "./addPlushGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports